import { LILAC_500, isValidObject, tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getBenefitWidgetStyles = (props, isSmallScreen) => {
  var spacing = tokens.spacing;
  var data = props.data,
    offerStripProps = props.offerStripProps,
    _props$showDivider = props.showDivider,
    showDivider = _props$showDivider === void 0 ? false : _props$showDivider;
  var length = data === null || data === void 0 ? void 0 : data.length;
  var isRowDirection = length < 3;
  return StyleSheet.create({
    container: Object.assign(Object.assign({
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between'
    }, isValidObject(offerStripProps) && {
      borderBottomLeftRadius: 0
    }), isValidObject(offerStripProps) && {
      borderBottomRightRadius: 0
    }),
    iconButtonContainer: {
      flex: 1,
      flexShrink: 0,
      flexDirection: 'row'
    },
    iconButtonItem: Object.assign({
      flex: 1,
      alignItems: 'center'
    }, isRowDirection && {
      flexDirection: 'row'
    }),
    iconContainerDivider: Object.assign({
      marginHorizontal: isSmallScreen ? spacing.SPACING_8 : spacing.SPACING_10
    }, showDivider && {
      width: 1,
      backgroundColor: LILAC_500
    }),
    icon: Object.assign({
      flexShrink: 0
    }, isRowDirection ? {
      marginRight: spacing.SPACING_8
    } : {
      marginBottom: spacing.SPACING_4
    }),
    labelTitleContainer: Object.assign({
      flexShrink: 1
    }, !isRowDirection && {
      alignItems: 'center'
    }),
    label: Object.assign({}, !isRowDirection && {
      textAlign: 'center'
    })
  });
};